module.exports = __webpack_public_path__ + "static/img/our-awards_4.444d9b5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/about-us/our-awards_4.png
// module id = spNe
// module chunks = 0